import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { projectInfo } from '../data/mock';

const EMBASSY_LOGO = "/embassy-logo.png";

const Header = ({ onEnquireClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#overview', label: 'Overview' },
    { href: '#gallery', label: 'Gallery' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#amenities', label: 'Amenities' },
    { href: '#location', label: 'Location' },
    { href: '#contact', label: 'Contact' }
  ];

  const scrollToSection = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-[#0a1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <img src={EMBASSY_LOGO} alt="Embassy Group" className="h-10 sm:h-12 w-auto" />

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navLinks.map((link) => (
              <button key={link.href} onClick={() => scrollToSection(link.href)} className="text-white/80 hover:text-[#c9a961] text-sm font-medium">
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <a href={`tel:${projectInfo.phone}`} className="flex items-center gap-2 text-white/80 hover:text-[#c9a961]">
              <Phone className="w-4 h-4" />
              <span className="text-sm">+91 9066840485</span>
            </a>
            <Button onClick={onEnquireClick} className="bg-gradient-to-r from-[#c9a961] to-[#a08545] text-[#0a1628] font-semibold px-6 py-2 rounded-full">
              Enquire Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-white p-2">
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`lg:hidden absolute top-full left-0 right-0 bg-[#0a1628]/98 backdrop-blur-md transition-all duration-300 ${isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <button key={link.href} onClick={() => scrollToSection(link.href)} className="block w-full text-left text-white/80 py-3 border-b border-white/10">
              {link.label}
            </button>
          ))}
          <Button onClick={() => { onEnquireClick(); setIsMobileMenuOpen(false); }} className="w-full bg-gradient-to-r from-[#c9a961] to-[#a08545] text-[#0a1628] font-semibold py-3 rounded-full mt-4">
            Enquire Now
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
